document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('QuickViewModal');
  const modalContent = document.getElementById('QuickViewContent');

  if (!modal || !modalContent) return;

  // Add click listener to the whole document to catch clicks on quick view buttons
  // (This helps with dynamically loaded products via load more)
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.js-quick-view-trigger');
    if (!trigger) return;

    e.preventDefault();
    const url = trigger.dataset.productUrl;
    if (!url) return;

    try {
      modal.showModal();
      modalContent.innerHTML = `
        <div class="quick-view-modal__loading">
          <div class="spinner"></div>
        </div>
      `;

      // Fetch the product section
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', 'product-quick-view');
      const response = await fetch(fetchUrl.toString());
      const text = await response.text();

      // Extract section HTML
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const sectionHtml = htmlDocument.getElementById('shopify-section-product-quick-view').innerHTML;

      modalContent.innerHTML = sectionHtml;

      // Ensure custom elements are evaluated properly by running their lifecycle hooks or re-evaluating scripts if necessary
      // If scripts were fetched dynamically, they don't execute automatically via innerHTML
      const scripts = modalContent.querySelectorAll('script');
      scripts.forEach(oldScript => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });

      // Re-initialize logic for the quick view modal
      initializeQuickViewLogic();

    } catch (error) {
      console.error('Error loading quick view:', error);
      modalContent.innerHTML = '<div class="quick-view-modal__error">Failed to load product.</div>';
    }
  });

  function initializeQuickViewLogic() {
    const variantRadios = modal.querySelectorAll('.variant-radio');
    const variantIdInput = modal.querySelector('.quick-view-modal__variant-id');
    const quantityInput = modal.querySelector('input[name="quantity"]');
    const quantityBtns = modal.querySelectorAll('.quantity-btn');
    const addToCartBtn = modal.querySelector('.js-add-to-cart-btn');
    const inventoryMessage = modal.querySelector('.quick-view-modal__inventory-message');
    const mainImage = modal.querySelector('.quick-view-modal__image');
    
    const productForm = modal.querySelector('.quick-view-modal__form');
    
    const variantsDataEl = modal.querySelector('.QuickViewVariantsData');
    const variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];

    function updateVariant() {
      if(!variantsData || variantsData.length === 0) return;
      
      let matchedVariant;
      
      if (variantRadios.length === 0) {
        // If there are no radio buttons, it's a product with only a default variant
        matchedVariant = variantsData[0];
      } else {
        const selectedOptions = Array.from(modal.querySelectorAll('.variant-radio:checked')).map(r => r.value);
        
        matchedVariant = variantsData.find(variant => {
          if(variant.options) {
             return variant.options.every((option, index) => option === selectedOptions[index]);
          }
          return false;
        });
      }

      if (matchedVariant) {
        if (variantIdInput) variantIdInput.value = matchedVariant.id;
        
        // Update price
        const priceContainer = modal.querySelector('.quick-view-modal__price');
        if (priceContainer) {
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            priceContainer.innerHTML = `
              <s class="quick-view-modal__price-compare">${matchedVariant.compare_at_price_formatted}</s>
              <span class="quick-view-modal__price-sale">${matchedVariant.price_formatted}</span>
            `;
          } else {
            priceContainer.innerHTML = `<span class="quick-view-modal__price-regular">${matchedVariant.price_formatted}</span>`;
          }
        }

        // Update badge
        const imageContainer = modal.querySelector('.quick-view-modal__image-container');
        if (imageContainer) {
          let badge = imageContainer.querySelector('.quick-view-modal__badge');
          
          if (matchedVariant.compare_at_price > matchedVariant.price && matchedVariant.available) {
            const discountAmount = matchedVariant.compare_at_price - matchedVariant.price;
            const discountPercentage = Math.round((discountAmount / matchedVariant.compare_at_price) * 100);
            
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'quick-view-modal__badge';
              imageContainer.appendChild(badge);
            }
            badge.textContent = `-${discountPercentage}%`;
          } else {
            if (badge) {
              badge.remove();
            }
          }
        }

        // Update pills UI
        modal.querySelectorAll('.variant-pill').forEach(pill => {
          pill.classList.remove('is-active');
        });
        
        variantRadios.forEach(radio => {
          if (radio.checked) {
            const pill = radio.closest('.variant-pill');
            if (pill) pill.classList.add('is-active');
          }
        });

        // Update Inventory message and Buttons
        if (matchedVariant.available) {
          if (addToCartBtn) addToCartBtn.disabled = false;
          
          const checkoutBtnWrapper = modal.querySelector('.js-checkout-button-wrapper');
          if (checkoutBtnWrapper) checkoutBtnWrapper.classList.remove('is-disabled');
          
          if (quantityInput) quantityInput.disabled = false;
          if (quantityBtns) quantityBtns.forEach(btn => btn.disabled = false);

          if (inventoryMessage) {
            if (matchedVariant.inventory_management !== null && matchedVariant.inventory_quantity <= 5 && matchedVariant.inventory_quantity > 0) {
              inventoryMessage.textContent = 'Low on stock';
            } else {
              inventoryMessage.textContent = '';
            }
          }
        } else {
          if (addToCartBtn) addToCartBtn.disabled = true;
          
          const checkoutBtnWrapper = modal.querySelector('.js-checkout-button-wrapper');
          if (checkoutBtnWrapper) checkoutBtnWrapper.classList.add('is-disabled');
          
          if (quantityInput) quantityInput.disabled = true;
          if (quantityBtns) quantityBtns.forEach(btn => btn.disabled = true);
          
          if (inventoryMessage) {
            inventoryMessage.textContent = 'Sold out';
          }
        }
        
        // Update main image if variant has one
        if (matchedVariant.featured_image_url && mainImage) {
           mainImage.src = matchedVariant.featured_image_url;
           mainImage.removeAttribute('srcset'); 
        }

        // Try to update the swiper if it exists
        const swiperContainer = modal.querySelector('product-quick-view-swiper .swiper');
        if (swiperContainer && swiperContainer.swiper) {
          // You could optionally seek the swiper to the index of the image if you knew it
          // Or just let the user swipe.
        }

        // Update Preorder 'Ships on' Property and UI
        const preorderPropertyInput = modal.querySelector('.js-preorder-property');
        const preorderBadge = modal.querySelector('.js-product-badge-preorder');
        const preorderDelivery = modal.querySelector('.js-product-preorder-delivery');
        const preorderDateDisplay = modal.querySelector('.js-preorder-date-display');
        const checkoutBtnWrapperForPreorder = modal.querySelector('.js-checkout-button-wrapper');

        if (
          matchedVariant.inventory_policy === 'continue' &&
          matchedVariant.inventory_quantity <= 0 &&
          matchedVariant.preorder_days_to_ship
        ) {
          const daysToShip = parseInt(matchedVariant.preorder_days_to_ship, 10);
          const shipDate = new Date();
          shipDate.setDate(shipDate.getDate() + daysToShip);
          
          const optionsWithYear = { year: 'numeric', month: 'short', day: 'numeric' };
          const formattedDateWithYear = shipDate.toLocaleDateString('en-US', optionsWithYear);
          
          const optionsWithoutYear = { month: 'short', day: 'numeric' };
          const formattedDateWithoutYear = shipDate.toLocaleDateString('en-US', optionsWithoutYear);

          if (preorderPropertyInput) {
            preorderPropertyInput.value = formattedDateWithYear;
            preorderPropertyInput.disabled = false;
          }
          if (preorderBadge) {
            preorderBadge.style.display = 'block';
          }
          if (preorderDelivery && preorderDateDisplay) {
            preorderDateDisplay.textContent = formattedDateWithoutYear;
            preorderDelivery.style.display = 'flex';
          }
          if (checkoutBtnWrapperForPreorder) {
            checkoutBtnWrapperForPreorder.classList.add('is-preorder');
          }
          if (addToCartBtn) {
            addToCartBtn.style.display = 'none';
          }
        } else {
          if (preorderPropertyInput) {
            preorderPropertyInput.value = '';
            preorderPropertyInput.disabled = true;
          }
          if (preorderBadge) {
            preorderBadge.style.display = 'none';
          }
          if (preorderDelivery) {
            preorderDelivery.style.display = 'none';
          }
          if (checkoutBtnWrapperForPreorder) {
            checkoutBtnWrapperForPreorder.classList.remove('is-preorder');
          }
          if (addToCartBtn) {
            addToCartBtn.style.display = '';
          }
        }
      }
    }
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', updateVariant);
    });

    quantityBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        if (!quantityInput) return;
        let currentVal = parseInt(quantityInput.value, 10);
        if (isNaN(currentVal)) currentVal = 1;
        
        if (this.dataset.action === 'plus') {
          quantityInput.value = (currentVal + 1).toString().padStart(2, '0');
        } else if (this.dataset.action === 'minus' && currentVal > 1) {
          quantityInput.value = (currentVal - 1).toString().padStart(2, '0');
        }
      });
    });
    
    // Format initial quantity
    if(quantityInput) {
       let currentVal = parseInt(quantityInput.value, 10);
       if (!isNaN(currentVal)) {
          quantityInput.value = currentVal.toString().padStart(2, '0');
       }
    }

    // Initialize variant state on load
    updateVariant();

    // Handle Add to Cart AJAX
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        let isBuyNow = false;
        if (document.activeElement && document.activeElement.classList.contains('shopify-payment-button__button')) {
          isBuyNow = true;
        }

        if (isBuyNow) {
          return; // Let inline native submit happen
        }

        e.preventDefault();
        
        const formData = new FormData(productForm);
        
        const originalBtnText = addToCartBtn ? addToCartBtn.textContent : '';
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Adding...';
        }

        const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          return response.json();
        })
        .then(() => {
          if (typeof window.showToast === 'function') {
            window.showToast('Item added to cart!');
          }

          // Update header cart count and the cart itself if we're on the cart page
          fetch(rootUrl + '?sections=header,cart')
            .then(res => res.json())
            .then(sections => {
              // Update Header Cart Count
              const headerHtml = sections['header'];
              if (headerHtml) {
                const parsedHeader = new DOMParser().parseFromString(headerHtml, 'text/html');
                const newCartBubble = parsedHeader.querySelector('#cart-icon-bubble');
                const currentCartBubble = document.getElementById('cart-icon-bubble');
                
                if (newCartBubble && currentCartBubble) {
                  currentCartBubble.innerHTML = newCartBubble.innerHTML;
                }
              }

              // Update Cart Items if we are on the cart page
              const cartHtml = sections['cart'];
              if (cartHtml) {
                 const parsedCart = new DOMParser().parseFromString(cartHtml, 'text/html');
                 const newCartItems = parsedCart.querySelector('cart-items');
                 const currentCartItems = document.querySelector('cart-items');
                 
                 if (newCartItems && currentCartItems) {
                    currentCartItems.innerHTML = newCartItems.innerHTML;
                 }
                 
                 // If the cart was empty but now has items, we might need to reload to show the structure properly
                 // Or we could replace the whole cart container
                 const newCartContainer = parsedCart.querySelector('.cart-container');
                 const currentCartContainer = document.querySelector('.cart-container');
                 if (newCartContainer && currentCartContainer) {
                    currentCartContainer.innerHTML = newCartContainer.innerHTML;
                 }
              }
              
              // Close the modal after adding to cart
              modal.close();
            });
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          alert('Error adding item to cart.');
        })
        .finally(() => {
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = originalBtnText;
          }
        });
      });
    }
  }
});
